<script setup lang="ts">
import { addError } from '@ui/components/notifications/useNotifications'
import Trash from '~icons/cue-regular/trash'

const props = withDefaults(
  defineProps<{
    userId?: number
    clientId?: number
  }>(),
  {},
)

const emit = defineEmits(['delete'])

const api = useApi().clients

const pending = ref(false)
function remove() {
  if (!props.clientId || !props.userId) {
    return
  }

  pending.value = true
  api.users
    .delete(props.clientId, props.userId)
    .then(() => {
      emit('delete')
    })
    .catch(e => {
      addError(e.data?.message || e.message)
    })
    .finally(() => {
      pending.value = false
    })
}
</script>

<template lang="pug">
UiIconButton(:name="Trash" :variant="ButtonVariant.FunctionAccent" :size="Sizes.Luke" :loading="pending" @click.prevent.stop="remove")
</template>
